(function () {
function init(root) {
if (!root || root.__blp) return; root.__blp = true;
var C = JSON.parse(root.querySelector('[data-blp-config]').textContent);
var P = C.product, V = P.variants;
var $ = function (s, r) { return (r || root).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
var optEls = $$('.blp-opt');
var N = P.options.length;
var FI = Math.max(0, P.options.map(function (o) { return typeof o === 'string' ? o : o.name; }).indexOf(C.finish));
var GI = C.galleryOpt ? P.options.map(function (o) { return typeof o === 'string' ? o : o.name; }).indexOf(C.galleryOpt) : -1;
var OPTS = []; // values per option index, in admin order, hidden values removed (taken from server markup)
for (var i = 0; i < N; i++) OPTS[i] = [];
optEls.forEach(function (el) { var i = +el.getAttribute('data-i'); OPTS[i] = $$('.blp-chip', el).map(function (b) { return b.getAttribute('data-v'); }); });
for (var k = 0; k < N; k++) if (!OPTS[k].length) OPTS[k] = [V[0].options[k]]; // single-value options

var idInput = $('[data-blp-id]');
var cur = V.filter(function (v) { return String(v.id) === idInput.value; })[0] || V[0];
var sel = cur.options.slice();

function money(cents) {
  var n = (cents / 100).toFixed(2), parts = n.split('.');
  var amt = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  var fmt = String(C.moneyFormat || '');
  var out = /\{\{\s*\w+\s*\}\}/.test(fmt) ? fmt.replace(/\{\{\s*\w+\s*\}\}/, amt) : '$' + amt;
  return out.replace(/<[^>]*>/g, '').replace(/\.00(?!\d)/, '');
}
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function handle(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
function sized(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function find(t) {
  for (var i = 0; i < V.length; i++) { var ok = true; for (var j = 0; j < N; j++) if (V[i].options[j] !== t[j]) { ok = false; break; } if (ok) return V[i]; }
  return null;
}
function anyWith(i, val, j, val2) { return V.some(function (v) { return v.options[i] === val && (j == null || v.options[j] === val2); }); }
function best(i, val) { // pick the closest variant after option i changes
  var top = null, score = -1;
  V.forEach(function (v) {
    if (v.options[i] !== val) return;
    var s = v.available ? 100 : 0;
    for (var j = 0; j < N; j++) if (j !== i && v.options[j] === sel[j]) s += 10 - j;
    if (OPTS.some(function (o, j) { return o.indexOf(v.options[j]) < 0; })) s -= 1000; // hidden value
    if (s > score) { score = s; top = v; }
  });
  return top;
}
function isLead(t) {
  if (!C.leadTrigger) return false;
  var trig = String(C.leadTrigger).toLowerCase();
  return t.some(function (o) { return String(o).toLowerCase().indexOf(trig) > -1; });
}
function preShip() { // pre-order variants come from the variant metafield custom.preorder
  var M = C.pre || {}, k = String(cur.id);
  return Object.prototype.hasOwnProperty.call(M, k) ? String(M[k] || '') : null;
}
var plateIdx = -1;
(C.plates || []).forEach(function (pl) { for (var i = 0; i < N; i++) if (OPTS[i].indexOf(pl.value) > -1) plateIdx = i; });

/* ---------- options ---------- */
function renderChips() {
  optEls.forEach(function (el) {
    var i = +el.getAttribute('data-i'), h = '';
    OPTS[i].forEach(function (val) {
      if (i !== FI && !anyWith(i, val, FI, sel[FI])) return; // e.g. no Open Comb in Black
      var t = sel.slice(); t[i] = val;
      var m = find(t), off = !m || !m.available;
      h += '<button type="button" class="blp-chip" aria-pressed="' + (sel[i] === val) + '"' + (off ? ' data-off' : '') + ' data-v="' + esc(val) + '">' +
        (i === FI ? '<span class="blp-sw blp-sw--' + handle(val) + '"></span>' : '') + esc(val) + '</button>';
    });
    $('.blp-chips', el).innerHTML = h;
    var vv = $('[data-blp-val]', el); if (vv) vv.textContent = sel[i];
    var note = $('[data-blp-optnote]', el);
    if (note) {
      var pl = i === plateIdx ? (C.plates || []).filter(function (p) { return p.value === sel[i]; })[0] : null;
      note.hidden = !(pl && pl.text); if (pl) note.textContent = pl.text;
    }
  });
}
$('[data-blp-opts]').addEventListener('click', function (e) {
  var b = e.target.closest('.blp-chip'); if (!b) return;
  var i = +b.closest('.blp-opt').getAttribute('data-i'), val = b.getAttribute('data-v');
  if (sel[i] === val) return;
  choose(i, val);
});
function choose(i, val) {
  var t = sel.slice(); t[i] = val;
  var m = find(t);
  if (!m || (!m.available && best(i, val) && best(i, val).available && i === FI)) m = best(i, val);
  if (!m) return;
  var finishChanged = m.options[FI] !== sel[FI] || (GI > -1 && m.options[GI] !== sel[GI]);
  sel = m.options.slice();
  update(finishChanged);
}

/* ---------- gallery ---------- */
var track = $('[data-blp-track]'), thumbs = $('[data-blp-thumbs]'), dots = $('[data-blp-dots]'), count = $('[data-blp-count]'), tag = $('[data-blp-galtag]');
var list = []; // {src, life}
function buildList(v) {
  var out = [], seen = {};
  function add(fm) { if (fm && fm.preview_image && !seen[fm.id]) { seen[fm.id] = 1; out.push({ id: fm.id, src: fm.preview_image.src }); } }
  add(v.featured_media);
  V.forEach(function (x) { if (x.options[FI] === v.options[FI] && (GI < 0 || x.options[GI] === v.options[GI])) add(x.featured_media); });
  String(C.mediaKeys || '').split(/\r?\n/).forEach(function (l) {
    var c = l.indexOf(':'); if (c < 0 || l.slice(0, c).trim() !== v.options[FI]) return;
    var keys = l.slice(c + 1).split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean);
    (P.media || []).forEach(function (m) { var s = m.preview_image && String(m.preview_image.src).toLowerCase(); if (s && keys.some(function (k) { return s.indexOf(k) > -1; })) add(m); });
  });
  if (C.shared) { var vm = {}; V.forEach(function (x) { if (x.featured_media) vm[x.featured_media.id] = 1; }); (P.media || []).forEach(function (m) { if (!vm[m.id]) add(m); }); } // accessory pages: also show photos not tied to a variant
  if (!out.length) (P.media || []).slice(0, 6).forEach(function (m) { if (m.preview_image) out.push({ id: m.id, src: m.preview_image.src }); });
  (C.life || []).forEach(function (s) { if (s) out.push({ src: s, life: true }); });
  return out;
}
function slideHtml(it, first) {
  if (it.life) return '<div class="blp-slide blp-slide--life"><img src="' + esc(it.src) + '" alt="' + esc(P.title) + '" loading="lazy"></div>';
  var ss = [500, 800, 1100, 1400].map(function (w) { return sized(it.src, w) + ' ' + w + 'w'; }).join(', ');
  return '<div class="blp-slide"><img src="' + sized(it.src, 1100) + '" srcset="' + ss + '" sizes="(min-width: 900px) 55vw, 100vw" alt="' + esc(P.title) + '"' + (first ? '' : ' loading="lazy"') + '></div>';
}
function renderGallery(rebuild) {
  if (rebuild) { list = buildList(cur); track.innerHTML = list.map(function (it, j) { return slideHtml(it, j === 0); }).join(''); track.scrollLeft = 0; }
  thumbs.innerHTML = list.map(function (it, j) {
    return '<button type="button" class="' + (it.life ? 'is-life' : '') + '" data-j="' + j + '" aria-label="Image ' + (j + 1) + '"><img src="' + (it.life ? esc(it.src) : sized(it.src, 200)) + '" alt="" loading="lazy"></button>';
  }).join('');
  dots.innerHTML = list.map(function () { return '<span></span>'; }).join('');
  tag.textContent = sel[FI];
  mark();
}
function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
function mark() {
  var j = Math.min(list.length - 1, Math.max(0, index()));
  $$('button', thumbs).forEach(function (b, n) { b.setAttribute('aria-current', n === j); });
  $$('span', dots).forEach(function (d, n) { d.className = n === j ? 'is-on' : ''; });
  if (count) count.textContent = (j + 1) + ' / ' + list.length;
  if (tag) tag.hidden = !!(list[j] && list[j].life);
}
function go(j, smooth) {
  j = (j + list.length) % list.length;
  track.scrollTo({ left: j * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
  setTimeout(mark, smooth === false ? 0 : 350);
}
var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(mark, 60); }, { passive: true });
thumbs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(+b.getAttribute('data-j')); });
$('[data-blp-prev]').addEventListener('click', function () { go(index() - 1); });
$('[data-blp-next]').addEventListener('click', function () { go(index() + 1); });
track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(index() - 1); if (e.key === 'ArrowRight') go(index() + 1); });
window.addEventListener('resize', function () { go(index(), false); });

/* ---------- stand ---------- */
var addon = $('[data-blp-addon]'), standBox = $('[data-blp-stand]'), standVar = null;
function renderStand() {
  if (!addon || !C.stand) return;
  var full = sel.join(' / ');
  standVar = C.stand.variants.filter(function (x) { return x.title === full; })[0] || C.stand.variants.filter(function (x) { return x.title === sel[FI] || x.option1 === sel[FI]; })[0] || null;
  addon.hidden = !(standVar && standVar.available);
  if (!standVar) return;
  $('[data-blp-standsub]').textContent = (standVar.title === full ? sel.join(' ') : sel[FI]) + ' ' + (C.standSub || '');
  $('[data-blp-standprice]').innerHTML = money(standVar.price) + (standVar.compare_at_price > standVar.price ? '<s>' + money(standVar.compare_at_price) + '</s>' : '');
}
function standOn() { return !!(standBox && standBox.checked && addon && !addon.hidden && standVar && standVar.available); }
if (standBox) standBox.addEventListener('change', function () { renderPrice(); });

/* ---------- blades (optional) ---------- */
var bladeBox = $('[data-blp-blades]');
function bladesOn() { return bladeBox ? $$('[data-blp-blade]', bladeBox).filter(function (b) { return b.checked; }) : []; }
function bladesTotal() { return bladesOn().reduce(function (s, b) { return s + (+b.getAttribute('data-price') || 0); }, 0); }
if (bladeBox) bladeBox.addEventListener('change', function () { renderPrice(); });

/* ---------- price, button, notes ---------- */
var priceEl = $('[data-blp-price]'), addBtn = $('[data-blp-add]'), lead = $('[data-blp-lead]');
var sticky = $('[data-blp-sticky]'), stickyBtn = $('[data-blp-stickybtn]'), stickyTxt = $('[data-blp-stickytxt]');
function renderPrice() {
  var was = cur.compare_at_price > cur.price ? cur.compare_at_price : 0;
  var pct = was ? Math.floor((was - cur.price) * 100 / was + 1e-9) : 0;
  priceEl.innerHTML = '<span class="blp-price__now">' + money(cur.price) + '</span>' +
    (was ? '<span class="blp-price__was">' + money(was) + '</span><span class="blp-price__tag">' + esc(String(C.saleLabel || '').replace('[percent]', pct)) + '</span>' : '');
  var total = cur.price + (standOn() ? standVar.price : 0) + bladesTotal();
  var ok = cur.available;
  var lbl = preShip() !== null ? (C.preLabel || C.addLabel) : C.addLabel;
  addBtn.disabled = !ok;
  addBtn.textContent = ok ? lbl + ' · ' + money(total) : C.soldoutLabel;
  if (stickyBtn) { stickyBtn.disabled = !ok; stickyBtn.textContent = ok ? lbl + ' · ' + money(total) : C.soldoutLabel; }
  if (stickyTxt) stickyTxt.textContent = sel.filter(function (o, i) { return OPTS[i].length > 1; }).join(' · ');
}
function renderPlates() {
  $$('.blp-plate').forEach(function (b) {
    var k2 = b.getAttribute('data-k'), on = plateIdx > -1 && sel[plateIdx] === k2;
    var can = plateIdx > -1 && anyWith(plateIdx, k2, FI, sel[FI]);
    b.setAttribute('aria-pressed', on); b.disabled = !can;
    var s = $('[data-blp-platesel]', b); if (s) s.textContent = on ? 'Selected' : (can ? 'Select' : 'Not in ' + sel[FI]);
  });
}
function update(rebuild) {
  cur = find(sel) || cur; sel = cur.options.slice();
  idInput.value = cur.id;
  renderChips(); renderStand(); renderPrice(); renderPlates();
  var ps = preShip();
  if (lead) lead.hidden = !isLead(sel) || ps !== null;
  var pn = $('[data-blp-pre]');
  if (pn) { pn.hidden = ps === null || !cur.available; if (ps !== null) $('span', pn).textContent = String(C.preNote || '').replace('[ship]', ps); }
  if (C.noretTrigger) {
    var nr = sel.indexOf(C.noretTrigger) > -1;
    var a2 = $('[data-blp-assure2]'); if (a2 && C.noretAssure) a2.textContent = nr ? C.noretAssure : C.assure2;
    var nl = $('[data-blp-noret]'); if (nl) nl.hidden = !nr;
  }
  if (rebuild) renderGallery(true);
  else { var j = -1; list.forEach(function (it, n) { if (j < 0 && cur.featured_media && it.id === cur.featured_media.id) j = n; }); if (j > -1) go(j); }
  try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
}
var plates = $('[data-blp-plates]');
if (plates) plates.addEventListener('click', function (e) {
  var b = e.target.closest('.blp-plate'); if (!b || b.disabled || plateIdx < 0) return;
  choose(plateIdx, b.getAttribute('data-k'));
  var buy = $('[data-blp-buy]'); if (buy && buy.getBoundingClientRect().bottom < 0) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* ---------- cart ---------- */
var toastTimer;
function toast(msg, link) {
  var t = document.querySelector('.blp-toast');
  if (!t) { t = document.createElement('div'); t.className = 'blp-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
  t.innerHTML = '<span>' + esc(msg) + '</span>' + (link ? '<a href="' + esc(C.cartUrl) + '">' + esc(C.viewCartLabel) + '</a>' : '');
  t.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 4000);
}
function drawerOpen() { var d = document.getElementById('sidebar-cart'); return d && d.getAttribute('aria-hidden') === 'false'; }
function openCart(item) {
  document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: item, quantity: 1 } }));
  setTimeout(function () {
    if (drawerOpen()) return;
    var trig = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]') || document.querySelector('[aria-controls="sidebar-cart"]');
    if (trig) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      trig.click();
      setTimeout(function () { if (!drawerOpen()) toast(C.addedLabel, true); }, 800);
    } else toast(C.addedLabel, true);
  }, 900);
}
function add(btn) {
  if (!cur.available) return;
  var props = {};
  var ps = preShip();
  if (ps !== null && C.preProp) props[C.preProp] = String(C.preVal || '').replace('[ship]', ps);
  else if (C.leadProp && C.leadVal && isLead(sel)) props[C.leadProp] = C.leadVal;
  var items = [{ id: cur.id, quantity: 1, properties: props }];
  if (standOn()) items.push({ id: standVar.id, quantity: 1 });
  bladesOn().forEach(function (b) { items.push({ id: +b.value, quantity: 1 }); });
  var label = btn.textContent; btn.disabled = true; btn.textContent = C.addingLabel;
  fetch(C.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
    .then(function (j) { openCart(j.items && j.items[0]); })
    .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart.', false); })
    .then(function () { btn.disabled = false; btn.textContent = label; renderPrice(); });
}
$('[data-blp-form]').addEventListener('submit', function (e) { e.preventDefault(); add(addBtn); });
if (stickyBtn) stickyBtn.addEventListener('click', function () { add(stickyBtn); });
if (sticky && 'IntersectionObserver' in window) {
  new IntersectionObserver(function (en) {
    var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
    sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); stickyBtn.tabIndex = on ? 0 : -1;
  }).observe(addBtn);
}

/* ---------- video ---------- */
var vid = $('[data-blp-video]');
if (vid) vid.addEventListener('click', function () {
  if (vid.__on) return; vid.__on = true;
  vid.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(vid.getAttribute('data-blp-video')) + '?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
});

list = buildList(cur);
if ($$('.blp-slide', track).length !== list.length) renderGallery(true); else renderGallery(false);
update(false);
}
function boot() { document.querySelectorAll('[data-blp-root]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-blp-root]')); });
})();
